import { CalendarDays, TicketPlus, TicketCheck, Clock } from 'lucide-react';
import { useWorkspaceContext } from '@/contexts/WorkspaceContext';
import { useTodayStats } from '@/hooks/useTodayStats';
import { Skeleton } from '@/components/ui/skeleton';

export function TodayStats() {
  const { activeWorkspace } = useWorkspaceContext();
  const { data: dailySummary, loading } = useTodayStats({ 
    workspaceId: activeWorkspace?.id 
  });

  const stats = [
    {
      label: 'Tickets créés',
      value: dailySummary.created,
      icon: TicketPlus,
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Tickets fermés',
      value: dailySummary.closed,
      icon: TicketCheck,
      color: 'text-luminjo-success',
      bgColor: 'bg-luminjo-success/10',
    },
    {
      label: 'Temps de réponse moyen',
      value: dailySummary.avgResponseTime !== null 
        ? dailySummary.avgResponseTime < 60 
          ? `${Math.round(dailySummary.avgResponseTime)}m`
          : `${Math.round(dailySummary.avgResponseTime / 60)}h`
        : '-',
      icon: Clock,
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
  ];

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-sm p-4">
        <div className="flex items-center gap-2 mb-4">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-24" />
        </div>
        <div className="grid grid-cols-3 gap-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-lg" />
              <div className="space-y-1">
                <Skeleton className="h-6 w-8" />
                <Skeleton className="h-3 w-16" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-4">
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground mb-4">
        <CalendarDays className="h-4 w-4" />
        <span>Aujourd'hui</span>
      </div>
      <div className="grid grid-cols-3 gap-4">
        {stats.map((stat) => (
          <div key={stat.label} className="flex items-center gap-3">
            <div className={`p-2.5 rounded-lg ${stat.bgColor}`}>
              <stat.icon className={`h-5 w-5 ${stat.color}`} />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stat.value}</p>
              <p className="text-xs text-muted-foreground">{stat.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
